import React, { PureComponent } from 'react';
import { Handler, InputType } from 'react-reactive-form';

interface CheckboxProps {
  children?: any;
  className?: string;
  id: string;
  disabled: boolean;
  handler: (inputType?: InputType, value?: string) => Handler;
}


export default class Checkbox extends PureComponent<CheckboxProps> {

  render() {
    return (
      <div className={`custom-control custom-checkbox${this.props.className ? ` ${this.props.className}` : ''}`}>
        <input
          className="custom-control-input"
          id={this.props.id}
          {...this.props.handler('checkbox')}
          disabled={this.props.disabled}
        />
        <label className="custom-control-label" htmlFor={this.props.id}>
          {this.props.children}
        </label>
      </div>
    );
  }
}

